exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.skeleton[data-v-86ccbae0] {\n  margin: 0 !important;\n  padding: 0 !important;\n  border-color: rgb(217, 217, 217);\n  border-radius: 4px;\n  height: 30px;\n}\n.column1[data-v-86ccbae0] {\n  width: 240px;\n}\n.column2[data-v-86ccbae0] {\n  width: 60px;\n}\n.column3[data-v-86ccbae0] {\n  width: 20px;\n}\n", ""]);

// exports
